module.exports = __webpack_public_path__ + "static/media/homo-logo.6b22989a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/homo-logo.jpg
// module id = 102
// module chunks = 0